angular.module('gym.calendar').controller('ChangeRepeatLimitCtrl', ["$scope", "$rootScope", "$modalInstance", "flash", "EditEventScheduleService", "ConfirmLeaveUnsavedChangesService", "EventService", "params", function($scope, $rootScope, $modalInstance, flash, EditEventScheduleService, ConfirmLeaveUnsavedChangesService, EventService, params) {
  var getRecurringBookings, getRepeatRule, gym;
  gym = $rootScope.gym;
  $scope.event = params.event;
  $scope.formParams = {};
  $scope.frequencyUpdateParams = {
    change_type: '',
    change_attributes: {}
  };
  ConfirmLeaveUnsavedChangesService.watch($scope, 'frequencyUpdateParams', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  getRecurringBookings = function() {
    var filters;
    filters = {
      event_schedule_id: $scope.event.event_schedule_id
    };
    return EventService.getRecurringBookings(filters).then(function(recurringBookings) {
      return $scope.recurringBookings = recurringBookings;
    });
  };
  getRecurringBookings();
  $scope.recurringBookingsWarningVisible = function() {
    var ref;
    return gym.gym_config.recurring_bookings_feature_enabled && ((ref = $scope.recurringBookings) != null ? ref.length : void 0);
  };
  getRepeatRule = function() {
    switch (false) {
      case !$scope.event.repeats:
        return 'repeats';
      case !$scope.event.repeat_until_date:
        return 'repeat_until_date';
      case !$scope.event.infinite:
        return 'infinite';
    }
  };
  $scope.formData = {
    repeatRule: getRepeatRule()
  };
  $scope.onRepeatTypeChange = function() {
    switch ($scope.formData.repeatRule) {
      case 'repeats':
        $scope.frequencyUpdateParams.change_type = 'change_repeat_until';
        $scope.frequencyUpdateParams.change_attributes = {
          repeats: $scope.event.repeats
        };
        break;
      case 'repeat_until_date':
        $scope.frequencyUpdateParams.change_type = 'change_repeat_until';
        $scope.frequencyUpdateParams.change_attributes = {
          repeat_until_date: $scope.event.repeat_until_date
        };
        break;
      case 'infinite':
        $scope.frequencyUpdateParams.change_type = 'change_to_infinite_events';
        $scope.frequencyUpdateParams.change_attributes = {};
    }
    return $scope.validate();
  };
  $scope.validate = function() {
    var isValid;
    isValid = (function() {
      switch ($scope.formData.repeatRule) {
        case 'repeats':
          return $scope.frequencyUpdateParams.change_attributes.repeats > 0;
        case 'repeat_until_date':
          return $scope.frequencyUpdateParams.change_attributes.repeat_until_date;
        default:
          return true;
      }
    })();
    return $scope.formParams.isInvalid = !isValid;
  };
  $scope.onRepeatTypeChange();
  $scope.isFormReady = function() {
    return !$scope.isLoading && !$scope.formParams.isInvalid;
  };
  return $scope.save = function() {
    $scope.isLoading = true;
    return params.save($scope.frequencyUpdateParams).then(function() {
      return $scope.close(true);
    }, function() {
      return $scope.isLoading = false;
    });
  };
}]);
